import React from "react";
import { Link } from "react-router-dom";

const SleeveMini = ({ sleeve }) => {
  return (
    <div className="sleeve-cover">
      {sleeve.img_path && (
        <Link to={`/sleeves/view/${sleeve.id}`} title={sleeve.title}>
          <img
            src={`https://res.cloudinary.com/dreamchimney/image/upload/w_220/sleevery/${sleeve.id}.jpg`}
            className="sleeve-mini center-block img-responsive"
          />
        </Link>
      )}
    </div>
  );
};

export default SleeveMini;
